// @ts-ignore
import Colcade from "colcade";

(() => {
  const containers = document.querySelectorAll<HTMLElement>('.subpages-masonry');
  if (!containers || !containers.length) {
    return;
  }
  containers.forEach((container) => {
    new Colcade(container, {
      columns: '.subpages-masonry__col',
      items: '.subpages-masonry__item',
    });
  });
})();
